module.exports = __webpack_public_path__ + "static/alexander-6eb6384ba97e663a13b621a3e3d25fa0.png";